// src/utils/detecSystemTheme.tsx
export function detectSystemTheme(): 'dark' | 'light' {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  }